<template>
	<div id="page-user-edit">
		<vx-card>
			<div slot="no-body" class="tabs-container px-6 pt-6">
				<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
					<vs-tab :label="$t('Indicators.IndicatorList')" icon-pack="feather" icon="icon-list">
						<div class="tab-text">
							<indicator-list-view
								class="mt-4"
								@selectedActivityEmit="selectedActivityEmit"
								v-if="indicatorsReadPermission"
							/>
							<not-permission v-else></not-permission>
						</div>
					</vs-tab>

					<vs-tab :label="nameTabOne" icon-pack="feather" icon="icon-info">
						<div class="tab-text">
							<indicator-create-tab-information
								class="mt-4"
								:data="indicatorData"
								@changeActiveTabEmit="changeActiveTab"
								v-if="indicatorData.id === 0"
							/>
							<indicator-create-tab-information
								class="mt-4"
								:data="indicatorData"
								@changeActiveTabEmit="changeActiveTab"
								v-else-if="indicatorData.id > 0"
							/>
							<not-permission v-else></not-permission>
						</div>
					</vs-tab>
				</vs-tabs>
			</div>
		</vx-card>
	</div>
</template>

<script>
import IndicatorCreateTabInformation from "./IndicatorCreateTabInformation.vue";
import IndicatorListView from "./IndicatorListView.vue";
import Indicator from "@/models/Indicator.js";
import NotPermission from "@/views/pages/NotPermission.vue";
import moduleTeams from "@/store/teams/moduleTeams.js";

export default {
	components: {
		IndicatorCreateTabInformation,
		IndicatorListView,
		NotPermission,
	},
	data() {
		return {
			indicatorData: new Indicator({}),
			user_not_found: false,
			activeTab: 0,
		};
	},
	computed: {
		nameTabOne() {
			return this.indicatorData.id > 0
				? this.$t("Indicators.UpdateIndicator")
				: this.$t("Indicators.CreateIndicator");
		},
		indicatorsReadPermission() {
			return this.$store.getters.checkPermission("INDICATORS_R");
		},
		indicatorsCreatePermission() {
			return this.$store.getters.checkPermission("INDICATORS_C");
		},
		indicatorsUpdatePermission() {
			return this.$store.getters.checkPermission("INDICATORS_U");
		},
	},
	watch: {
		activeTab(tabNum) {
			if (tabNum === 0) {
				this.indicatorData = new Indicator({});
			}
		},
	},
	methods: {
		selectedActivityEmit(activity) {
			this.indicatorData = activity;
			this.activeTab = 1;
		},
		changeActiveTab(tabNum) {
			this.activeTab = tabNum;
		},
	},
	created() {
		if (!moduleTeams.isRegistered) {
			this.$store.registerModule("moduleTeams", moduleTeams);
			moduleTeams.isRegistered = true;
		}
	},
};
</script>
